import { withHook } from 'utils/withHook';
import { useCropImageModalState } from 'containers/CropImageModal/logic/useCropImageModalState';
import { CropImageModalView } from 'containers/CropImageModal/view/CropImageModalView';

export const CropImageModal = withHook(useCropImageModalState)(
  CropImageModalView
);
